import {
  AfterContentInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  Inject,
  NgZone,
  ViewEncapsulation,
  forwardRef,
} from '@angular/core';
import { CdkScrollable, ScrollDispatcher } from '@angular/cdk/scrolling';
import { ContentMargin } from '../../content-margin.interface';
import { SEECH_LAYOUT_CONTAINER } from '../../layout.token';

@Component({
  selector: 'seech-layout-content',
  template: '<ng-content></ng-content>',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./layout-content.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: CdkScrollable,
      useExisting: LayoutContentComponent,
    },
  ],
})
export class LayoutContentComponent
  extends CdkScrollable
  implements AfterContentInit
{
  @HostBinding('attr.ngSkipHydration') ngSkipHydrationAttribute = '';
  @HostBinding('class') get content() {
    return 'seech-layout-content';
  }
  @HostBinding('style.margin-left.px') get contentMarginLeft() {
    return this.container.contentMargins.left;
  }
  @HostBinding('style.margin-right.px') get contentMarginRight() {
    return this.container.contentMargins.right;
  }

  @HostBinding('attr.ngSkipHydration') _ngSkipHydrationAttribute = '';

  @HostBinding('class') get _content() {
    return 'seech-layout-content seech-sidenav-content';
  }

  constructor(
    private cdRef: ChangeDetectorRef,
    @Inject(forwardRef(() => SEECH_LAYOUT_CONTAINER))
    public container: ContentMargin,
    elementRef: ElementRef<HTMLElement>,
    scrollDispatcher: ScrollDispatcher,
    ngZone: NgZone
  ) {
    super(elementRef, scrollDispatcher, ngZone);
  }

  ngAfterContentInit() {
    this.container.contentMarginChanges.subscribe(() => {
      this.cdRef.markForCheck();
    });
  }
}
